import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
    FormularioGetModel,
    FormularioPerguntaGetModel,
    FormularioPreenchidoPostModel,
    RespostaFormularioPostModel,
    TipoPergunta,
    TipoPerguntaLabel
} from 'app/models/formulario.model';
import { FormularioService } from 'app/services/formulario.service';
import { NotificacaoService } from 'app/services/notificacao.service';

@Component({
    selector: 'app-formulario-preenchimento',
    templateUrl: './formulario-preenchimento.component.html',
    styleUrls: ['./formulario-preenchimento.component.scss'],
    standalone: false
})
export class FormularioPreenchimentoComponent implements OnInit {
    @Input() clienteId: number = 0;
    @Input() formularioId: number = 0;
    @Input() preenchidoId: number = 0;

    formulario: FormularioGetModel | null = null;
    respostas: { [perguntaId: number]: string } = {};
    loading = false;

    TipoPergunta = TipoPergunta;
    TipoPerguntaLabel = TipoPerguntaLabel;

    constructor(
        private activeModal: NgbActiveModal,
        private formularioService: FormularioService,
        private notificacaoService: NotificacaoService
    ) { }

    async ngOnInit(): Promise<void> {
        this.loading = true;
        try {
            if (this.preenchidoId > 0) {
                const preenchido = await this.formularioService.obterPreenchido(this.preenchidoId);
                this.formulario = await this.formularioService.obterPorId(preenchido.formularioId);
                this.formularioId = preenchido.formularioId;
                preenchido.respostas.forEach(r => {
                    this.respostas[r.formularioPerguntaId] = r.resposta || '';
                });
            } else if (this.formularioId > 0) {
                this.formulario = await this.formularioService.obterPorId(this.formularioId);
            }
        } catch (err) {
            this.notificacaoService.mensagemErro('Erro ao carregar formulário');
            this.activeModal.close(false);
        } finally {
            this.loading = false;
        }
    }

    getOpcoes(pergunta: FormularioPerguntaGetModel): string[] {
        if (!pergunta.opcoes) return [];
        return pergunta.opcoes.split(',').map(o => o.trim()).filter(o => o.length > 0);
    }

    isMultiplasSelecionadas(perguntaId: number, opcao: string): boolean {
        const resposta = this.respostas[perguntaId] || '';
        const selecionadas = resposta.split(',').map(s => s.trim());
        return selecionadas.includes(opcao);
    }

    toggleMultipla(perguntaId: number, opcao: string): void {
        const resposta = this.respostas[perguntaId] || '';
        const selecionadas = resposta.split(',').map(s => s.trim()).filter(s => s.length > 0);
        const index = selecionadas.indexOf(opcao);
        if (index >= 0) {
            selecionadas.splice(index, 1);
        } else {
            selecionadas.push(opcao);
        }
        this.respostas[perguntaId] = selecionadas.join(', ');
    }

    cancelar(): void {
        this.activeModal.close(false);
    }

    confirmar(): void {
        if (!this.formulario) return;

        // Validate required fields
        for (const pergunta of this.formulario.perguntas) {
            if (pergunta.obrigatoria && !String(this.respostas[pergunta.id] ?? '').trim()) {
                this.notificacaoService.mensagemAlerta(`A pergunta "${pergunta.texto}" é obrigatória.`);
                return;
            }
        }

        const model = new FormularioPreenchidoPostModel();
        model.id = this.preenchidoId;
        model.formularioId = this.formularioId;
        model.clienteId = this.clienteId;
        model.respostas = this.formulario.perguntas.map(p => {
            const resp = new RespostaFormularioPostModel();
            resp.formularioPerguntaId = p.id;
            resp.resposta = String(this.respostas[p.id] ?? '');
            return resp;
        });

        this.loading = true;
        const observable = this.preenchidoId > 0
            ? this.formularioService.atualizarPreenchido(model)
            : this.formularioService.adicionarPreenchido(model);

        observable.subscribe({
            next: (resp) => {
                this.notificacaoService.mensagemSucesso(resp.mensagem);
                this.activeModal.close(true);
            },
            error: (err) => {
                this.loading = false;
                this.notificacaoService.mensagemErro(err?.error?.mensagem || 'Erro ao salvar preenchimento');
            }
        });
    }
}
